/* eslint-disable react/jsx-max-props-per-line */
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import MenuItemIcon from './MenuItemIcon';

export const BannerComponent = (props) => {
    const {
        className,
        iconColor,
        iconName,
        iconSide,
        iconSize,
        iconSvg,
        id,
        label,
        rendered,
        renderLabel,
        title,
        variant,
        subLabel,
        closeable,
        handleHide,
        rightIconItems,
        children,
        ignoreRightIconItems,
    } = props;
    let ariaLabel = '';

    if (rendered) {
        return (
            <div className={`p-banner ${className !== undefined ? className : ''} ${variant !== undefined ? variant : ''}`}>
                <div className='banner-container'>
                    <span
                        title={`${title ? title : ''}${ariaLabel}`}
                        tabIndex='0'
                        id={id}
                        key={id === undefined ? `BannerComponent-${label}` : id}
                    >
                        {renderLabel ? (
                            renderLabel()
                        ) : (
                            <React.Fragment>
                                <div className={`row `}>
                                    <div
                                        className={`${iconName !== undefined ? 'icon_text' : ''} p-banner-text p-c ${
                                            iconName !== undefined ? iconColor : ''
                                        } ${subLabel ? 'p-banner-text-sublabel' : ''} col-md-6 col-xs-12`}
                                    >
                                        <div className={`banner-content ${closeable ? 'closeable' : ''}`}>
                                            {iconSide === 'left' && iconName !== undefined ? (
                                                <i alt='' className={`icon mdi ${iconName} ${iconSize}`} />
                                            ) : null}
                                            {iconSide === 'left' && iconSvg !== undefined ? (
                                                <MenuItemIcon alt='' className={`icon-svg ${iconSize} ${iconSide}`} iconSvg={iconSvg} />
                                            ) : null}
                                            <div>
                                                <div>{label}</div>
                                                {subLabel ? (
                                                    <div
                                                        className={`${iconName !== undefined ? 'icon_text' : ''} p-banner-text p-c ${
                                                            iconName !== undefined ? iconColor : ''
                                                        } p-banner-text-sublabel`}
                                                    >
                                                        <div className=''>
                                                            <span className=''>
                                                                <label
                                                                    className={
                                                                        iconSide === 'left' && iconSvg !== undefined
                                                                            ? `p-label sub-label sub-label-banner-left-icon`
                                                                            : `p-label sub-label`
                                                                    }
                                                                >
                                                                    {subLabel}
                                                                </label>
                                                            </span>
                                                        </div>
                                                    </div>
                                                ) : null}
                                            </div>
                                            {iconSide === 'right' && iconName !== undefined ? (
                                                <i alt='' className={`icon mdi ${iconName} ${iconSize}`} />
                                            ) : null}
                                        </div>
                                    </div>
                                    {!ignoreRightIconItems && rightIconItems && rightIconItems.length ? (
                                        <div className={`col-md-6 col-xs-12 right-banner-icons ${closeable ? 'closeable' : ''}`}>
                                            {rightIconItems.map((item, index) => {
                                                return (
                                                    <MenuItemIcon
                                                        key={`right-icon-item-${index}`}
                                                        alt=''
                                                        id={`right-icon-item-${index}`}
                                                        className={`${item.iconSize} right-banner-icon ${
                                                            closeable && index === rightIconItems.length - 1 ? 'next-close' : ''
                                                        }`}
                                                        iconSvg={item.iconSvg}
                                                        handleClick={item.handleClick}
                                                    />
                                                );
                                            })}
                                        </div>
                                    ) : null}
                                    {!!children ? (
                                        <div className={`col-md-6 col-xs-12 banner-children ${closeable ? 'closeable' : ''}`}>
                                            {children}
                                        </div>
                                    ) : null}
                                    {closeable ? (
                                        <MenuItemIcon
                                            alt=''
                                            className={`close-banner-icon`}
                                            iconSvg={'ico_close_banner'}
                                            handleClick={handleHide}
                                        />
                                    ) : null}
                                </div>
                            </React.Fragment>
                        )}
                    </span>
                </div>
            </div>
        );
    } else return null;
};

BannerComponent.defaultProps = {
    colClass: 'col-xl-4 col-lg-6 col-md-6 col-sm-12',
    iconSide: 'right',
    size: 'normal',
    variant: 'blue-banner',
    rendered: true,
    closeable: false,
    ignoreRightIconItems: false,
};

BannerComponent.propTypes = {
    className: PropTypes.string,
    colClass: PropTypes.string,
    iconColor: PropTypes.string,
    iconLabel: PropTypes.string,
    iconName: PropTypes.string,
    iconSide: PropTypes.string,
    iconSize: PropTypes.string,
    id: PropTypes.string,
    label: PropTypes.string.isRequired,
    renderLabel: PropTypes.func,
    rendered: PropTypes.bool,
    size: PropTypes.string,
    title: PropTypes.string,
    variant: PropTypes.string,
    subLabel: PropTypes.string,
    closeable: PropTypes.bool,
    handleHide: PropTypes.func,
    customMenuIcons: PropTypes.array,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    ignoreRightIconItems: PropTypes.bool,
};

export default withTranslation()(BannerComponent);
